var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSearchMore = function SvgSearchMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4C11.623 4 4 11.623 4 21c0 9.377 7.623 17 17 17a16.89 16.89 0 009.938-3.234l13.148 13.148 2.828-2.828-13.027-13.027C36.444 29.083 38 25.224 38 21c0-9.377-7.623-17-17-17zm0 2c8.296 0 15 6.704 15 15s-6.704 15-15 15S6 29.296 6 21 12.704 6 21 6zm-8 13a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2zm8 0a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2zm8 0a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2z"
  })));
};

export default SvgSearchMore;